import { State } from '../../../../types';
import { Tag } from '../../components/assets/types';

export function getTags(state: State): Tag[] {
    return state.tags.tags;
}

export function isTaggingServiceAvailable(state: State): boolean {
    return state.tags.available;
}
